module.exports = __webpack_public_path__ + "assets/img/1.774c21ba.jpg";